var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5C13.0668 5 13.5263 5.48215 13.5263 6.07692V12.1026H17.9737C18.3888 12.1026 18.763 12.3649 18.9218 12.7674C19.0807 13.1698 18.9929 13.633 18.6994 13.941L13.2257 19.6846C13.1234 19.7919 13.0048 19.8719 12.8783 19.9244C12.7613 19.9732 12.6336 20 12.5 20C12.3553 20 12.2176 19.9686 12.0927 19.9119C11.9943 19.8673 11.9011 19.8057 11.8173 19.7272C11.8009 19.7119 11.7851 19.6961 11.7697 19.6797L6.30063 13.941C6.00711 13.633 5.9193 13.1698 6.07815 12.7674C6.23701 12.3649 6.61124 12.1026 7.02634 12.1026H11.4737V6.07692C11.4737 5.48215 11.9332 5 12.5 5Z",
    fill: "#2c8ec6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.7f5c46da1a15f2b9631e1dd3486f2bd6.svg";
export { ForwardRef as ReactComponent };